import React, { useContext, useEffect, useState } from "react";
import { IToastContext, ToastContext } from "../../../providers/Toast";
import PageHeader from "../../../components/shared/pageHeader/PageHeader";
import { useTranslation } from "react-i18next";
import StandsList from "../../../components/stands/list";
import Button from "../../../components/shared/button/Button";
import { DB_DEFAULTS } from "../../../firebase/collections";
import { getStands } from "../../../context/stands/action";
import { useDispatch, useSelector } from "react-redux";
import { StandsState } from "../../../context/stands/reducer";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  isChat?: boolean;
  title?: string;
  description?: string;
  showBackgroundImage?: boolean;
}

const StandsListView = ({
                          isChat,
                          title,
                          description,
                          showBackgroundImage = true,
                          ...restProps
                        }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Reference to Redux store dispatch function: use it to dispatch actions.
  const dispatch = useDispatch();

  // Access to toast manager hook that you may use to show toasts.
  const { openToast } = useContext<IToastContext>(ToastContext);

  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  const [requested, setRequested] = useState<boolean>(false);

  // Pagination
  const [lastItem, setLastItem] = useState<any>(null);
  const [limit, setLimit] = useState<number>(DB_DEFAULTS.LIMIT);

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------
  const { stands, loading, canLoadMore, error } = useSelector(
    ({ standsReducer }: { standsReducer: StandsState }) => {
      return standsReducer;
    },
  );

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * Load stands from database
   * @function
   * @async
   */
  const loadMoreStands = async () => {
    dispatch(getStands(limit, lastItem));
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[StandsListView] init");
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[StandsListView] destroy");
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();

    return () => {
      destroy();
    };
  }, []);

  /**
   * Hook to stands in order to load stands data
   */
  useEffect(() => {
    if (!stands || !stands.length) {
      if (!requested) {
        dispatch(getStands(limit, lastItem));
        setRequested(true);
      }
    } else {
      setLastItem(stands[stands.length - 1]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stands]);

  /**
   * Hook to error in order to handle errors
   */
  useEffect(() => {
    if (!!error) {
      console.error(error);
      openToast({
        type: "error",
        title: "errors.general.title",
        message: "errors.general.description",
        callback: () => {
        },
      });
    }
  }, [error]);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <>
      <div className="page-content">
        <div className={`container ${showBackgroundImage ? "full-page" : ""}`}>
          {!!showBackgroundImage && (
            <div className="full-page-image">
              <img src="/assets/images/undraw/exposition.png" alt=""/>
            </div>
          )}

          <div className="d-flex align-items-center justify-content-between stands-header">
            <PageHeader title={title ? title : t("pages.standsList.title")}/>
            <div className="stands-icons d-flex align-items-center justify-content-around">
              {["sponsor", "basic", "advanced", "advanced-plus"].map((level: string) => (
                <div className="d-flex align-items-center justify-content-around" key={level}>
                  <label>{level.toUpperCase()}</label>
                  <span className={`meeters-iconset-${level} meeters-badge`}/>
                </div>
              ))}
            </div>
          </div>

          {!!description && <p className="description mb-4">{description}</p>}

          <div className={"stands-list"}>
            {!!stands && stands.length > 0 && <StandsList isChat={isChat} stands={stands}/>}
          </div>

          {!!loading && (
            <div className="list-loading">
              <i className="fas fa-spin fa-spinner"></i>
            </div>
          )}

          {/* Load more button */}
          {!loading && !!canLoadMore && (
            <div className="load-more">
              <Button className="btn btn-primary" onClick={loadMoreStands}>
                Load more
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default StandsListView;
